import home from './home.json';
import login from './login.json';

export default { home, login };
